import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

const useEmpNOC = (formData, workflowDetails, userRolesArray, urlFormType, nocResponse) => {
  const [loading, setLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState(null);

  const { id } = useParams();
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  console.log(useParams(), "paramsHookFromMapSUb", userDetails);
  const { t } = useTranslation();
  const [iframeSrc, setIframeSrc] = useState("");
  const [requestLetterUrl, setRequestLetterUrl] = useState("");
  const [pdfIframeSrc, setPdfIframeSrc] = useState("");
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("EMP_NOC", formData);
  const getRequestLetterURL = async () => {
    const fileStoreId = formData?.nocLetterInfo?.find((item) => item.businessService === userDetails?.organisationCode)?.fileStoreId;
    const url = await getDocumentByFileStoreId(fileStoreId, setLoading, true);
    setIframeSrc(url);

    console.log("urlFromGetRequestLetterURL", url);

    return url;
  };

  const history = useHistory();
  let user = Digit.UserService.getUser();
  const [currentTab, setCurrentTab] = useState("0");
  const [currentAction, setCurrentAction] = useState("");
  const [currentView, setCurrentView] = useState("documents");
  const userInfo = Digit.UserService.getUser()?.info || {};
  const authToken = Digit.UserService.getUser()?.access_token || null;
  const [typeOfLetter, setTypeOfLetter] = useState("");
  const [customLetter, setCustomLetter] = useState([]);
  const [updatedDocuments, setUpdatedDocuments] = useState(formData?.documents);
  const [updatedInspectionReportData, setUpdatedInspectionReportData] = useState(formData?.inspectionDetailData);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [taxHead, setTaxHead] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [error, setError] = useState(false);
  const [officerNocDetails, setOfficerNocDetails] = useState(formData?.nocDetails);
  // Normal remarks
  const [developerRemarks, setDeveloperRemarks] = useState(null);
  // Document Remarks
  const isCitizen = user?.info?.type === "CITIZEN";
  const [developerRemarksDocument, setDeveloperRemarksDocument] = useState(null);
  const nocAppNo = Digit.SessionStorage.get("nocAppNo") || null;

  const currentNOCDept = userDetails?.organisationCode;
  const nocFormData = isCitizen
    ? params?.nocList?.find((item) => item?.applicationNo === nocAppNo)
    : params?.nocList?.find((item) => item?.businessService === currentNOCDept);
  const [nocOfficerRemarks, setNocOfficerRemarks] = useState(nocFormData?.termsAndCondition || "");
  // Noc remarks
  const [developerNocRemarks, setDeveloperNocRemarks] = useState(null);
  const [dataNocRecommendation, setDataNocRecommendation] = useState("");
  const [dataRecommendation, setDataRecommendation] = useState("");
  const [dataRecommendationDocument, setDataRecommendationDocument] = useState("");
  // const [developerUpdateDocument, setDeveloperUpdateDocument] = useState("");
  const [selectedObjection, setSelectedObjection] = useState("");
  const [mapSubNocDetails, setMapSubNocDetails] = useState(params?.nocDetails);
  const [additionalNocDocs, setAdditionalNocDocs] = useState([]);
  // const nocInitialValue =
  //   (formData?.riskType != "LOW" && Object.values(formData?.nocDetails?.officerNOCData)?.some(Boolean)) ||
  //   formData?.nocDetails?.additionalOfficerNOCData?.length > 0;
  const [isNoNoc, setIsNoNoc] = useState(true);
  const [nocRemarksData, setNocRemarksData] = useState({});
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const isEE = userRolesArray?.[0]?.code === "EE";
  const isEmployee = history.location.pathname.includes("employee");
  const [mapSubmissionAction, setMapSubmissionAction] = useState(null);
  const isDa = formData?.department === "DA";
  const inspectionReportChecklist = useSelector((state) => state.inspectionReportChecklist);
  const reduxFormData = useSelector((state) => state?.inspectionReportData);
  console.log("formDataNOC", formData, urlFormType);
  const isNocModule = urlFormType === "NOC";
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, isNocModule ? "NOC" : false);
  const userRolesWithoutEMP = user?.info?.roles.filter((user) => user.code != "EMPLOYEE");
  const drawingPdfs = formData?.documents?.filter((doc) => ["drawingPdf"].includes(doc.documentType));
  const Modal = useModal();
  const appType = formData?.applicationType;
  const isMapSubmission = appType === "FORM_MAP";
  const [initialUrl, setInitialUrl] = useState("");
  const currentFormData = params?.nocList?.find((item) => item?.businessService === userDetails?.organisationCode);
  console.log("nocFormData", nocFormData, "currentFormData", currentFormData, "formData", formData);
  const requestLetterId = currentFormData?.nocLetterInfo?.fileStoreId;
  const excludedTypes = ["signature", "applicantPhoto", "sitePhoto"];
  const excludedTypesForDocSection = [...excludedTypes, "sitePhoto", "kmlFile"];

  const documentSection = formData?.documents?.filter((doc) => !["signature", "applicantPhoto", "typeOfLetterDoc"].includes(doc.documentType));
  const fetchInitialUrl = async (fileStoreId) => {
    const response = await axios.get(`/filestore/v1/files/url?tenantId=up&fileStoreIds=${fileStoreId}`);
    // console.log("responseFromFileStore", response.data.fileStoreIds[0].url);
    // setInitialUrl(response.data.fileStoreIds[0].url);
    setIframeSrc(response.data.fileStoreIds[0].url);
    // return response.data.fileStoreIds[0].url || "";
  };
  const fetchInitialPdfUrl = async (fileStoreId) => {
    const response = await axios.get(`/filestore/v1/files/url?tenantId=up&fileStoreIds=${fileStoreId}`);
    console.log("responseFromFileStore", response?.data?.fileStoreIds?.[0]?.url);
    // setInitialUrl(response.data.fileStoreIds[0].url);
    setPdfIframeSrc(response.data.fileStoreIds[0].url);
    // return response.data.fileStoreIds[0].url || "";
  };
  const getValidityOfEmp = () => {
    if (formData?.assignes?.length > 0) {
      console.log("loggingValidityOfEmp", formData?.assignes?.[0]?.uuid === userInfo?.uuid);

      return formData?.assignes?.[0]?.uuid === userInfo?.uuid;
    }
    return true;
  };
  const isValidEmp = getValidityOfEmp();
  useEffect(async () => {
    const isDocValidated = formData?.documents?.some((item) => item.documentRemarks !== null);
    // const isDocValidated = formData?.documents?.every((item) => !item.isMandatory || item.documentRemarks !== null);
    // const isDocValidated = formData?.documents
    //   ?.filter((item) => !excludedTypesForDocSection.includes(item.documentType))
    //   .every((item) => !item?.isMandatory || item?.documentRemarks !== null);
    const isNocValidated =
      (formData?.nocDetails?.officerNOCData && Object.values(formData?.nocDetails?.officerNOCData)?.some(Boolean)) ||
      formData?.nocDetails?.additionalOfficerNOCData?.length > 0;
    console.log("isValidationsss", { isDocValidated, isNocValidated });

    if (isDocValidated) {
      Digit?.SessionStorage.set("isDocValidated", isDocValidated);
    }
    if (isNocValidated) {
      Digit?.SessionStorage.set("isNocValidates", isNocValidated);
    }
    // const isPaymenthead = formData?.taxHeadEstimates?.some((item) => item.calculationBusinesserviceId == "BPA.MAP_SUBMISSION_FORM_FEE2");
    // if (isPaymenthead) {
    //   Digit?.SessionStorage.set("isPaymenthead", isPaymenthead);
    // }
    const result = await getRequestLetterURL();
    setRequestLetterUrl(result);
    fetchInitialUrl(documentSection?.[0]?.fileStoreId);
    if (drawingPdfs) {
      fetchInitialPdfUrl(drawingPdfs?.[0]?.fileStoreId);
    }
  }, []);
  const handleDocView = () => {
    setCurrentView((prev) => (prev === "documents" ? "viewDocuments" : "documents"));
  };

  const handleLetterView = () => {
    setCurrentView((prev) => (prev === "letter" ? "viewDocuments" : "letter"));
  };
  const handleNoWorkflow = (updatedDocuments) => {
    if (!isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    const workflow = {
      action: "NOWORKFLOW",
      comments: "",
    };
    const appData = {
      ...formData,
      workflow,
      documents: updatedDocuments,
      // taxHeadEstimates: [...formData?.taxHeadEstimates, ...taxHeadData] || [],
      // inspectionDetailData:
      //     userRolesArray?.[0]?.code === "JE"
      //         ? data
      //         : formData?.inspectionDetailData,
    };
    updateApiCall.mutate(
      { BPA: appData },
      {
        onSuccess: (result) => {
          console.log("resultFromUpdate", result);
          // setDeveloperUpdateDocument("DocumentDetailsUpdated");
          onSelect("", result?.BPA?.[0]);
          // const isDocValidated = result?.BPA?.[0]?.documents?.some((item) => item.documentRemarks !== null);
          const isDocValidated = result?.BPA?.[0]?.documents?.every((item) => !item.isMandatory || item.documentRemarks !== null);
          Digit?.SessionStorage.set("isDocValidated", isDocValidated); // Modal(`Application updated.`, `Application Updated Successfully!`, "success", "/digit-ui/employee");
          // Modal(`Payment head updated`, `Payment heads for <strong>(${formData?.applicationNo})</strong> updated successfully!`, "success");
        },
      }
    );
  };
  const handleNoWorkflowNoc = (nocDetails, setLoading) => {
    if (!isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    setLoading(true);
    const workflow = {
      action: "NOWORKFLOW",
      comments: "",
    };
    const appData = {
      ...formData,
      workflow,
      nocDetails: nocDetails,
      // taxHeadEstimates: [...formData?.taxHeadEstimates, ...taxHeadData] || [],
      // inspectionDetailData:
      //     userRolesArray?.[0]?.code === "JE"
      //         ? data
      //         : formData?.inspectionDetailData,
    };
    updateApiCall.mutate(
      { BPA: appData },
      {
        onSuccess: (result) => {
          console.log("resultFromUpdate", result);
          onSelect("", result?.BPA?.[0]);
          setLoading(false);
          // const isDocValidated = result?.BPA?.[0]?.documents?.some((item) => item.documentRemarks !== null);
          Digit?.SessionStorage.set("isNocValidated", true); // Modal(`Application updated.`, `Application Updated Successfully!`, "success", "/digit-ui/employee");
          Modal(`NOC details updated`, `NOC details for <strong>(${formData?.applicationNo})</strong> updated successfully!`, "success");
        },
      }
    );
  };
  // const initialUrl =  fetchInitialUrl(documentSection?.[0]?.fileStoreId).then((url) => {
  //   console.log("initialUrl", url);
  // });

  const stripHtmlTags = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.innerText || tempDiv.textContent || ""; // Get the plain text
  };
  const getTabIndex = (isDa, isEE, baseIndex) => {
    const result = !isDa && isEE ? baseIndex : baseIndex + 1;
    console.log("loggingGetTabIndex", String(result)); // or result.toString()
    return String(result); // Convert the result to a string before returning
  };
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({ ...data });
    } else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };
  const isJE = userRolesArray?.[0]?.code === "JE";
  console.log(reduxFormData, inspectionReportChecklist?.inspectionReportData, "logging111111111111", developerRemarks);
  let userRole = userRolesArray?.[0]?.code;
  let schemeType = formData?.descriptionOfLand?.schemeType;
  let landArea = formData?.descriptionOfLand?.landArea;
  let primaryUse = formData?.primaryUse;

  let isResidential = primaryUse === "Residential";
  let isCommercial = primaryUse === "Commercial";
  let isScheme = schemeType === "Scheme";
  let isUnapproved = schemeType !== "Scheme";
  const isLowRiskCase = formData?.riskType === "LOW";

  console.log(
    { isResidential, isCommercial, isScheme, isUnapproved, userRole, landArea },
    workflowDetails?.data?.actionState?.nextActions,
    "loggingConditions"
  );

  let actions = workflowDetails?.data?.actionState?.nextActions
    ?.filter((item) => {
      if (isNocModule) {
        return item.action === "DEEMED_APPROVAL" ? false : true;
      }
    })
    .map((item) => ({
      ...item,
      action: `NOC_ACTION_${item.action}`,
    }));

  let tabList = [
    { label: "Application Data", color: "red" },
    { label: "Documents", color: "red" },
    { label: "Drawings", color: "red" },
    { label: "Site Inspection", color: "green" },
    (!isDa && !isEE) || isDa ? { label: "Payment Heads", color: "red" } : null,
    { label: "WF_TAKE_ACTION", color: "red" },
    { label: "ES_APPLICATION_DETAILS_APPLICATION_ALL_REMARKS", color: "green" }, // PurchasableFAR Checklist & FAR Details
    { label: "ChatBoard", color: "green" },
    { label: "Letter", color: "green" },
  ].filter(Boolean);
  const searchNocRemarks = async (applicationNumber) => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken,
      },
    };
    try {
      const Resp = await axios.post(`${Urls.bpaService.nocRemarks}&applicationNo=${applicationNumber}`, dataToSend).then((response) => {
        return response.data;
      });
      console.log("ResponseFromLog2222", Resp);
      setNocRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const createNocRemarks = async () => {
    // console.log("selectedObjection1", selectedObjection);

    setLoader(true);
    const applicationId = (nocAppNo && (nocAppNo.nocAppNo || nocAppNo.value?.nocAppNo)) || nocFormData?.applicationNo || formData?.applicationNo;
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN",
      },
      DetailDataRemarks: {
        userDetails: {
          userID: userInfo?.id || null,
          name: userInfo?.name || null,
          employeeName: userInfo?.name || null,
          role: userRolesArray?.[0]?.code,
          applicationID: applicationId,
          designation: userRolesArray?.[0]?.name,
          applicationStatus: nocFormData?.applicationStatus,
        },
        ...(isCitizen ? { applicantRemarks: remarks } : { nocOfficerRemarks: remarks }),
        isApproved: "nocRemarks",
        nocOfficerRemarks: nocOfficerRemarks || "",
        applicantRemarks: remarks || "",
        documentDetailsLtp: uploadedFiles,
      },
    };

    try {
      const Resp = await axios.post(Urls.bpaService.remarksDetail, postData, {}).then((response) => {
        console.log("log", Resp, response.data);
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
    // Modal("Documents remarks saved.", `Remarks for <strong>${formData?.applicationNo}</strong> saved successfully`, "success");
    await searchNocRemarks(nocFormData?.applicationNo);
    // handleChange(undefined, "2");
  };

  const moduleHandlers = {
    NOC: (context) => {
      const currentNOCDept = context.userDetails?.organisationCode;
      const nocPayload = isCitizen
        ? context.formData?.nocList?.find((item) => item?.applicationNo === nocAppNo.nocAppNo)
        : context.formData?.nocList?.find((item) => item?.businessService === currentNOCDept);
      console.log("loggingNocPayload", nocPayload, context.formData, context.userDetails, nocAppNo, currentNOCDept);

      return {
        Noc: {
          ...nocPayload,
          termsAndCondition: nocOfficerRemarks,
          workflow: {
            action: context.mapSubmissionAction?.action,
            comment: context.remarks,
            nocDocuments: uploadedFiles,
            nocDetails: nocOfficerRemarks,
          },
        },
      };
    },
    BPA: (context) => {
      return {
        BPA: {
          ...context.formData,
          customLetter: context.typeOfLetter,
          nocDetails: context.params?.nocDetails,
          workflow: {
            action: context.mapSubmissionAction?.action,
            comments: context.remarks,
          },
          documents: [...context.params?.documents, ...context.customLetter],
          taxHeadEstimates: [...context.formData?.taxHeadEstimates, ...context.taxHead] || [],
          inspectionDetailData: ["JE", "EE"].includes(context.userRolesArray?.[0]?.code)
            ? context.siteInspectionRemarksData?.DetailDataRemarks?.[0]?.inspectionDetails
            : context.formData?.inspectionDetailData,
        },
      };
    },
  };
  const validateBeforeSubmit = ({ isValidEmp, currentAction, mapSubmissionAction, isDocValidated, remarks, setError }) => {
    if (!isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return false;
    }

    if (!currentAction?.action && !mapSubmissionAction?.action) {
      Modal("Action required", "Please select at least one action.", "error");
      return false;
    }

    if (!isDocValidated) {
      Modal("Review documents section", "Please review the documents section and click on Save", "error");
      return false;
    }

    const plainText = stripHtmlTags(nocOfficerRemarks || remarks);
    if (plainText.trim().length === 0) {
      setError(true);
      return false;
    }

    setError(false);
    return true;
  };
  useEffect(() => {
    searchNocRemarks(currentFormData?.applicationNo);
  }, [currentFormData?.applicationNo]);
  const onSuccessHandlers = {
    NOC: (formData, currentAction, t, clearParams, payload) => {
      Modal(
        `Application ${t(currentAction?.action)}`,
        `Application <strong>(${formData?.applicationNo}) ${t(currentAction?.action)}</strong> updated successfully.`,
        "success",

        !isCitizen ? "/digit-ui/employee" : `digit-ui/citizen/obps/services/${payload?.Noc?.applicationNo}`
      );
      clearParams();
      Digit?.SessionStorage.del("EMP_NOC");
      Digit?.SessionStorage.del("isDocValidated");
      Digit?.SessionStorage.del("isNotingValidated");
      Digit?.SessionStorage.del("isPaymenthead");
      // Add any NOC-specific session cleanup here
    },

    BPA: (formData, currentAction, t, clearParams) => {
      Modal(
        `Application ${t(currentAction?.action)}`,
        `Application <strong>(${formData?.applicationNo}) ${t(currentAction?.action)}</strong> updated successfully.`,
        "success",
        "/digit-ui/employee"
      );
      clearParams();
      Digit?.SessionStorage.del("EMP_NOC");
      Digit?.SessionStorage.del("isDocValidated");
      Digit?.SessionStorage.del("isNotingValidated");
      Digit?.SessionStorage.del("customLetter");
      // Add any BPA-specific session cleanup here
    },
  };

  const handleSubmit = () => {
    const context = {
      isNocModule,
      userDetails,
      formData,
      mapSubmissionAction: {
        ...mapSubmissionAction,
        action: mapSubmissionAction?.action?.replace("NOC_ACTION_", ""),
      },
      currentAction,
      remarks,
      typeOfLetter,
      params,
      customLetter,
      taxHead,
      userRolesArray,
    };

    // const isDocValidated = Digit?.SessionStorage?.get("isDocValidated");

    const isValid = validateBeforeSubmit({
      isValidEmp,
      currentAction,
      mapSubmissionAction: context.mapSubmissionAction,
      isDocValidated: true,
      remarks,
      setError,
    });

    if (!isValid) return;

    setLoader(true);

    const moduleKey = isNocModule ? "NOC" : "BPA";
    const payload = moduleHandlers[moduleKey](context);
    console.log("payloadFromSubmit", payload, "context", context, isNocModule);
    createNocRemarks();
    updateApiCall.mutate(payload, {
      onSuccess: (result) => {
        onSuccessHandlers[moduleKey](formData, currentAction, t, clearParams, payload);
      },
    });

    setLoader(false);
  };

  const handleNoWorkflowPayNOC = (data) => {
    const context = {
      isNocModule,
      userDetails,
      formData,
      mapSubmissionAction: {
        ...mapSubmissionAction,
        action: mapSubmissionAction?.action?.replace("NOC_ACTION_", ""),
      },
      currentAction,
      remarks,
      typeOfLetter,
      params,
      customLetter,
      taxHead,
      userRolesArray,
    };
    console.log(data, "datatara");
    if (!isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    setLoading(true);
    const workflow = {
      action: "NOWORKFLOW",
      comments: "",
    };
    const moduleKey = isNocModule ? "NOC" : "BPA";
    const payload = moduleHandlers[moduleKey](context);
    console.log("payloadFromSubmit", payload, "context", context, isNocModule);
    const appData = {
      ...nocFormData,
      ...data,
      workflow,
    };
    updateApiCall.mutate(
      { Noc: appData },
      {
        onSuccess: (result) => {
          console.log(result, "result");
          setLoading(false);
          Modal(
            "Payment details updated",
            `Payment details for <strong>(${result?.Noc?.[0]?.applicationNo})</strong> updated successfully!`,
            "success",
            null,
            () => window.location.reload(),
            "OK"
          );
        },
      }
    );
  };

  // DocumentDetails API Call

  // PaymentDetails API Call

  // NotingDetails API Call

  // NocDetails API Call

  const onDropDownSelect = (event) => {
    const value = event.target.value;
    if (isMapSubmission) {
      console.log("radioAction", value);
      setMapSubmissionAction(value);
      setCurrentAction(value);
    } else {
      setCurrentAction(value);
    }
    function onSelect(val) {
      if (val !== selectedOption || props.allowMultiselect) {
        props.select(val);
        setSelectedOption(val);
        setDropdownStatus(false);
      } else {
        setSelectedOption(val);
        setforceSet(forceSet + 1);
      }
    }
  };
  console.log(dataRecommendationDocument, developerRemarksDocument, updatedDocuments, "loggingDataRecommendation");

  useEffect(() => {
    if (
      dataRecommendationDocument &&
      developerRemarksDocument &&
      updatedDocuments?.filter((doc) => doc.isMandatory)[0]?.documentRemarks &&
      isValidEmp
      // &&
      // developerUpdateDocument === "DocumentDetailsUpdated"
    ) {
      callDocumentDetailsAPI();
    }
  }, [dataRecommendationDocument, developerRemarksDocument, updatedDocuments?.[0]?.documentRemarks, isValidEmp]); // 🔒 empty dependency = runs only once after first render

  useEffect(() => {
    const applicationNumber = formData?.applicationNo;

    if (!applicationNumber) {
      console.warn("⚠️ Application number not found yet.");
      return;
    } // Call all 3 API functions
    onSelect("", formData);
    // handleGetPaymentHeadById(applicationNumber);
    // handleGetSiteInspectionById(applicationNumber);
    // handleGetDrawingById(applicationNumber);
    // handleGetFiledsStatesById(applicationNumber);
    // handleGetRemarkssValues(applicationNumber);
    // handleGetNotingById(applicationNumber);
    // handleGetNocById(applicationNumber);
    // handleGetHistoryRemarkssValues(applicationNumber);
  }, [formData?.applicationNo]); // 🔒 empty dependency = runs only once after first render

  console.log("dataRecommendation000", dataRecommendation, developerRemarks, updatedDocuments);

  const handleChange = (event, nextTab) => {
    setCurrentTab(nextTab);
  };
  const onRadioActionSelect = (value) => {
    setCurrentAction(value);
  };
  const filters = {
    // appType:formType,
    applicationNo: id,
  };
  console.log("loggingActionsFromHook", actions);

  return {
    handleChange,
    currentTab,
    tabList,
    currentAction,
    setCurrentAction,
    onRadioActionSelect,
    Modal,
    tenantId,
    actions,
    handleSubmit,
    error,
    setError,
    updatedDocuments,
    setUpdatedDocuments,
    isCitizen,
    updateApiCall,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    taxHead,
    setTaxHead,
    documentSection,
    isPreviewLoading,
    setIsPreviewLoading,
    iframeSrc,
    setIframeSrc,
    handleDocView,
    currentView,
    setCurrentView,
    initialUrl,
    developerRemarks,
    setDeveloperRemarks,
    drawingPdfs,
    pdfIframeSrc,
    setPdfIframeSrc,
    setDataRecommendation,
    setDeveloperNocRemarks,
    setDataNocRecommendation,
    dataRecommendation,
    setDeveloperRemarksDocument,
    setDataRecommendationDocument,
    developerRemarksDocument,
    dataRecommendationDocument,
    setSelectedObjection,
    setCustomLetter,
    setTypeOfLetter,
    onDropDownSelect,
    setMapSubmissionAction,
    mapSubmissionAction,
    userRolesArray,
    loader,
    params,
    setParams,
    clearParams,
    onSelect,
    handleNoWorkflow,
    mapSubNocDetails,
    setMapSubNocDetails,
    officerNocDetails,
    setOfficerNocDetails,
    isNoNoc,
    setIsNoNoc,
    handleNoWorkflowNoc,
    handleNoWorkflowPayNOC,
    isValidEmp,
    requestLetterId,
    currentFormData,
    nocOfficerRemarks,
    setNocOfficerRemarks,
    uploadedFiles,
    setUploadedFiles,
    nocFormData,
    searchNocRemarks,
    nocRemarksData,
  };
};
export default useEmpNOC;
